import {AppReflowPageVariantID} from '../constants';
import {WIX_NEW_STORES} from '@wix/app-definition-ids';
import {EditorSDK} from '@wix/platform-editor-sdk';

export const addReflowPage = async (
  editorSDK: EditorSDK,
  variantId: AppReflowPageVariantID,
  pageId: string,
  pageTitle: string
) => {
  let newPage: any;
  if (
    variantId === AppReflowPageVariantID.DuplicateOriginalProductPage ||
    variantId === AppReflowPageVariantID.DuplicateVariantProductPage ||
    variantId === AppReflowPageVariantID.DuplicateOriginalCategoryPage ||
    variantId === AppReflowPageVariantID.DuplicateVariantCategoryPage
  ) {
    newPage = await editorSDK.pages.duplicate('', {
      pageId,
      shouldAddMenuItem: false,
      shouldDuplicatePageCode: true,
    });
  } else if (
    variantId === AppReflowPageVariantID.StartFromBlankProductPage ||
    variantId === AppReflowPageVariantID.StartFromBlankCategoryPage
  ) {
    newPage = await editorSDK.pages.add('', {
      title: pageTitle,
      shouldAddMenuItem: false,
      shouldNavigateToPage: true,
      definition: {data: {managingAppDefId: WIX_NEW_STORES}},
    });
  }

  return newPage;
};
